<template>
  <div class="animated fadeIn">
    <div class="page-header d-flex" style="margin: 12px 12px 5px 12px;">
      <h4 class="page-title">
        <i class="fas fa-table"></i>
        エージェント
      </h4>
      <ul class="breadcrumbs ml-auto">
          <li class="nav-home mr-1">
              <a href="#">
                <i class="fas fa-home text-muted"></i>
              </a>
          </li>
          <li class="nav-item">
              <a class="font_15" href="#">WSFinder</a>
          </li>
          <li class="separator">
              <i class="fa fa-angle-right"></i>
          </li>
          <li class="nav-item">
              <a class="font_15 font-weight-bold" href="#">エージェント</a>
          </li>
      </ul>
    </div>
    <vcl-facebook v-if="loading"></vcl-facebook>
    <b-card v-else>
    <!-- <router-view @refresh="refresh()"></router-view> -->
    <div>
      <span class="font-weight-bold">
        {{model.host || '-'}}
        ({{(model.ip_addr_public ? model.ip_addr_public : model.ip_addr) || '-'}})
      </span>
      <b-badge variant="success" v-if="model.alive == true">オンライン({{model.ms}} ms)</b-badge>
      <b-badge v-else>オフライン</b-badge>
      <b-badge v-if="model.alive == true && model.status && model.status.running && model.status.is_real_time == false" variant="primary">
        セルフチェック
      </b-badge>
      <b-badge v-else-if="model.alive == true && model.status && (model.setting.realtime_mode || model.status.scaning_real_time == true)" variant="warning">
        リアルタイムモニタリング
      </b-badge>
      <span class="float-right">インストール日 : {{model.created_at | datetime}} </span>
    </div>
    <hr>
    <b-card v-if="!quick_setting_status">
      <b-row>
        <b-col md="4" class="text-center" style="height:180px;">
          <div
            @click="modal_modify = true"
            :style="`cursor:pointer;display: inline-block; background-color: ${model.status.last_detect_count ? 'orange' : 'skyblue'}; border:1px solid ${model.status.last_detect_count ? 'orange' : 'skyblue'}; width:150px; font-weight: 800; height:150px; border-radius:75px; text-align:center; margin:0 auto; font-size:15px; color:#fff; vertical-align:middle; line-height:150px`"
          >
            <small class="font-weight-bold">{{model.name}}</small>
          </div>
        </b-col>
        <b-col md="8" style="height:fit-content;">
          <table class="w-100">
            <thead>
              <th class="p-1">#</th>
              <th class="p-1">時間</th>
              <th class="p-1">詳細</th>
            </thead>
            <tbody>
              <tr>
                <td class="p-1">最近のチェック結果</td>
                <td class="p-1" v-if="model && model.status">{{model.status.last_scan_date | datetime}} </td>
                <td class="p-1" v-else>-</td>
                <td class="p-1">
                  合計 : {{model.status.last_scan_count || 0 }} ファイル確認
                </td>
                <td>
                  <b-btn block class="float-right" size="sm" variant="primary" @click="modal_modify = true"> ニックネームの変更 </b-btn>
                </td>
              </tr>
              <tr>
                <td class="p-1">最近の検出内容</td>
                <td class="p-1" v-if="model && model.status">{{model.status.last_detect_date | sdate}} </td>
                <td class="p-1" v-else>-</td>
                <td class="p-1">
                  合計 : {{model.status.last_detect_count || 0 }} ファイル確認
                </td>
                <td>
                  <b-btn block class="float-right btn-add" size="sm" variant="success" @click="modal_upgrade = true"> アップグレードエージェント</b-btn>
                </td>
              </tr>
              <tr>
                <td class="p-1">タッチタイム</td>
                <td class="p-1" v-if="model && model.touched_at">{{model.touched_at | sdate}} </td>
                <td class="p-1" v-else>-</td>
                <td class="p-1">
                  -
                </td>
                <td>
                  <b-btn block class="float-right" size="sm" variant="danger" @click="del_confirm = true"> 削除</b-btn>
                </td>
              </tr>
            </tbody>
          </table>
        </b-col>
      </b-row>
      <hr>
      <b-row>
        <!-- 메모리 차트 영역 -->
        <b-col class="fadeIn fadeOut" :md="model.status.system_cpu_info && model.status.system_cpu_info.usages && model.status.system_cpu_info.usages.length > 0 ? 4 : 6">
          <div v-if="model.chart.memory.series && model.chart.memory.series.length > 0">
            <VueApexCharts type="area" height="150" ref="_chart_memory" :options="model.chart.memory" :series="model.chart.memory.series" />
          </div>
        </b-col>
        <!-- cpu 차트 영역 -->
        <b-col class="fadeIn fadeOut" :md="model.status.system_cpu_info && model.status.system_cpu_info.usages && model.status.system_cpu_info.usages.length > 0 ? 4 : 6">
          <div v-if="model.chart.memory.series && model.chart.memory.series.length > 0">
            <VueApexCharts type="area" height="150" ref="_chart_cpu" :options="model.chart.cpu" :series="model.chart.cpu.series" />
          </div>
        </b-col>
        <!-- cpu work load -->
        <b-col class="fadeIn fadeOut" md="4">
          <div v-if="model.status.system_cpu_info && model.status.system_cpu_info.usages && model.status.system_cpu_info.usages.length > 0">
            <VueApexCharts type="heatmap" height="140" ref="_chart_workload" :options="model.chart.workload" :series="model.chart.workload.series" />
          </div>
        </b-col>
      </b-row>
      <hr>
      <b-row class="text-center">
        <b-col>
          <b-form-group>
            <div slot="label" class="font-weight-bold">
              ホスト
            </div>
            {{model.host}}
          </b-form-group>
        </b-col>
        <b-col>
          <b-form-group>
            <div slot="label" class="font-weight-bold">
              IP
            </div>
            <span v-if="!model.ip_addr_public || !model.ip_addr_private">{{model.ip_addr}}</span>
            <span v-else>
              <span v-if="model.ip_addr_public">
                <span v-if="model.ip_addr_public == model.ip_addr_private">
                  {{ model.ip_addr_public }}
                </span>
                <span v-else>
                  {{ model.ip_addr_public }} /  {{ model.ip_addr_private }}
                </span>
              </span>
              <span v-else>
                {{ model.ip_addr_private }}
              </span>
            </span>
          </b-form-group>
        </b-col>
        <b-col>
          <b-form-group>
            <div slot="label" class="font-weight-bold">
              OS
            </div>
            {{model.os_type}}
          </b-form-group>
        </b-col>
        <b-col>
          <b-form-group>
            <div slot="label" class="font-weight-bold" v-b-tooltip.hover.right title="アップデートが利用可能になると通知が届きます">
              <span>
                バージョン
                <Bell style="display: inline-block;" :size="20" :count="1" v-if="!is_latest()"/>
              </span>
            </div>
            {{model.version}}
          </b-form-group>
        </b-col>
        <b-col>
          <b-form-group>
            <div slot="label" class="font-weight-bold">
              WFDetector
            </div>
            <strong>
              <b-badge class="" :variant="model.setting.forgery_mode ? 'success' : 'default'" >{{ model.setting.forgery_mode ? 'Enable' : 'disable' }}</b-badge>
            </strong>
          </b-form-group>
        </b-col>
      </b-row>
      <hr>
      <b-row>
        <b-col md="6" v-if="model.setting.scan_list && model.setting.scan_list.length > 0">
          <center class="m-1">フォルダプレビューを監視</center>
          <white-Path :preview="true" :white_path="model.setting.scan_list || []" :show="true" @save="index = 0"></white-Path>
        </b-col>
        <b-col md="6" v-else>
          <center class="m-1">監視フォルダーはありません</center>
        </b-col>
        <b-col md="6" v-if="model.setting.white_path && model.setting.white_path.length > 0">
          <center class="m-1">例外フォルダのプレビュー</center>
          <white-Path :preview="true" :white_path="[].concat(model.setting.white_path || []).concat(model.setting.white_file || [])" :show="true" @save="index = 0"></white-Path>
        </b-col>
        <b-col md="6" v-else>
          <center class="m-1">例外フォルダはありません</center>
        </b-col>
      </b-row>
    </b-card>
    <hr>
    <template v-if="quick_setting_status" class="animated fadeIn fadeOut">
      <SettingQuickSetup
        v-if="quick_setting_status"
        :is_one="is_one"
        :is_first="is_first"
        :dir="dir"
        :scan_list="scan_list"
        :now_setting="model.setting"
        :os_type="model.os_type"

        @status="() => { quick_setting_status = false; is_first = false }"
        @remove="remove_select"
        @clear="clear"
        @get_path="(x) => { this.get_path(x) }"
        @save_quick="(setting) => { this.model = Object.assign({}, this.model, { setting : setting }); this.save_setting() }"
      >
      </SettingQuickSetup>
    </template>
      <b-tabs v-else active-nav-item-class="font-weight-bold text-uppercase text-danger" v-model="index">
        <b-tab @click="folder()" title="フォルダー">
          <folderSet
          :os_type="model.os_type"
            :is_refresh="model.alive"
            :show="dir.length"
            :item="dir"
            :scan_list="scan_list"
            :scan_list_history="model.setting.scan_list_history"
            :white_path="white_path"
            :white_file="white_file"
            :disk_list="disckStatus"

            @path="get_path"
            @save="folder_save"
            @remove="remove_select"
            @clear="clear"

            @add_white_list_file="add_white_list_file"
            @add_white_list="add_white_list"
            @add_scan_list="add_scan_list"

          />
        </b-tab>
        <b-tab title="設定">
          <b-row class="text-center">
            <b-col md="2">
            </b-col>
            <b-col md="4">
              <b-button block size="sm" variant="success" @click="save_setting" :disabled="runStatus" class="pr-2 pl-2 btn-add" style="min-width: 5.0rem;">
                {{ runStatus ? "Scanning, try later" : 'Save' }}
              </b-button>
            </b-col>
            <b-col md="4">
              <b-form-group>
                <b-button block size="sm" variant="warning" @click="apply_modal = true">
                  他のサーバに適用
                </b-button>
                <br>
                <small class="font-weight-bold text-danger">* 設定タブのすべての設定は、選択したエージェントに適用されます</small>
              </b-form-group>
            </b-col>
            <b-col md="4">
            </b-col>
          </b-row>
              <hr>
              <b-row class="text-center">
                <b-col>
                  <b-form-group :label-cols="4">
                    <div slot="label" class="font-weight-bold">
                      <span v-b-tooltip.hover.right title="検査に使用するポリシーを設定する">
                        * スキャンポリシー
                        <span class="text-info">
                          <i style="cursor:pointer" class="fas fa-question-circle"></i>
                        </span>
                      </span>

                    </div>
                <b-form-checkbox-group id="ph_status" v-model="model.setting.rule">
                  <b-form-checkbox value="Regex">正規表現</b-form-checkbox>
                  <b-form-checkbox value="Hash">ハッシュ</b-form-checkbox>
                  <b-form-checkbox value="Url">Url</b-form-checkbox>
                  <b-form-checkbox value="Ssdeep">Ssdeep</b-form-checkbox>
                  <b-form-checkbox value="OB">難読化</b-form-checkbox>
                  <b-form-checkbox value="ML" v-if="is_show_beta()">機械学習</b-form-checkbox>
                </b-form-checkbox-group>
                <b-form-input v-if="model.setting.rule.indexOf('ML') > -1" placeholder="この URL をフィールドに入力します" type="text" v-model="model.setting.url"></b-form-input>
              </b-form-group>
              <br>
              <b-form-group :label-cols="4">
                <div slot="label" class="font-weight-bold">
                  <span v-b-tooltip.hover.right title="リアルタイム監視するかどうかを設定します">
                     リアルタイム監視
                    <span class="text-info">
                      <i style="cursor:pointer" class="fas fa-question-circle"></i>
                    </span>
                  </span>
                </div>
                <b-form-radio-group v-model="model.setting.realtime_mode">
                  <b-form-radio :value="true">有効</b-form-radio>
                  <b-form-radio :value="false">無効</b-form-radio>
                </b-form-radio-group>
              </b-form-group>

            </b-col>
            <b-col class="border-left">
              <b-form-group :label-cols="4" label="">
                <div slot="label" class="font-weight-bold">
                  <span v-b-tooltip.hover.right title="検査スケジュールを設定します。夜明けまたはサーバー リソースに負荷がかかっていない時間帯に、最大 10 個の構成を推奨します。">
                    * スキャンスケジュール
                    <span class="text-info">
                      <i style="cursor:pointer" class="fas fa-question-circle"></i>
                    </span>
                    <br>
                    <small>最大10個のスケジュールを利用可能</small>
                  </span>
                </div>
                <Schedule :now_schedule="model.setting.schedule" @save="x => model.setting.schedule = x" :hide_text="true" />
              </b-form-group>
            </b-col>
          </b-row>
          <hr>
          <b-row class="text-center">
            <b-col>
              <b-form-group :label-cols="2">
                <div slot="label" class="font-weight-bold">
                  <span v-b-tooltip.hover.right title="検出された Web シェル ファイルをバックアップするかどうかを設定します。バックアップ後、ファイルは Web からアクセスできなくなります。これは推奨設定ですが、タイプミスのあるファイルはバックアップされる可能性があります。">
                    隔離モード
                    <span class="text-info">
                      <i style="cursor:pointer" class="fas fa-question-circle"></i>
                    </span>
                  </span>
                </div>
                <b-form-radio-group style="display:inline-block" v-model="model.setting.backup_mode">
                  <b-form-radio :value="false">手動</b-form-radio>
                  <b-form-radio :value="true">自動</b-form-radio>
                </b-form-radio-group>
                [
                <b-form-checkbox-group style="display:inline-block" v-model="model.setting.backup_type_list" :disabled="!model.setting.backup_mode">
                  <b-form-checkbox value="Regex">正規表現</b-form-checkbox>
                  <b-form-checkbox value="Hash">ハッシュ</b-form-checkbox>
                  <b-form-checkbox value="Url">Url</b-form-checkbox>
                  <b-form-checkbox value="Ssdeep">SSDEEP</b-form-checkbox>
                  <!-- <b-form-checkbox value="OB">難読化</b-form-checkbox> -->
                  <!-- <b-form-checkbox value="ML">機械学習</b-form-checkbox> -->
                </b-form-checkbox-group>
                ] <br> <small class="text-danger">* 難読化によって自動的な分離ができません</small>
              </b-form-group>
            </b-col>
            <b-col class="border-left">
              <b-form-group :label-cols="3">
                <div slot="label" class="font-weight-bold">
                  <span v-b-tooltip.hover.right title="分離パスを設定します パスが存在しない場合は、そのパス上にフォルダーが自動的に作成されます Windows の場合はデフォルトで「C:\wfinder_backup」、Linux の場合は「/opt/f1/wsfinder_backup」がインストール時にデフォルトに設定されます">
                    隔離モード
                    <span class="text-info">
                      <i style="cursor:pointer" class="fas fa-question-circle"></i>
                    </span>
                  </span>
                </div>
                <b-input-group>
                  <b-form-input placeholder="フォルダーパスが必要です" id="input-small3" type="text" v-model="model.setting.backup_path"></b-form-input>
                  <b-button size="sm" variant="link" @click="modal_scan_list_history = true">既往歴</b-button>
                </b-input-group>
              </b-form-group>
            </b-col>
          </b-row>
          <b-row class="text-center">
            <b-col>
              <hr>
              <b-button class="btn-addition" style="position: relative; top:-30px; width: 80%;" v-b-toggle.collapse-1-inner size="sm" variant="light">オプションの追加</b-button>
            </b-col>
          </b-row>

          <b-collapse id="collapse-1-inner" class="mt-2">
            <b-row>
              <b-col>
                <b-form-group :label-cols="3">
                  <div slot="label" class="font-weight-bold">
                    <span v-b-tooltip.hover.right title="検査対象の拡張子でフィルタリングできます 特定のファイルのみを監視する場合に使用します">
                      エクステンションの設定
                      <span class="text-info">

                        <i style="cursor:pointer" class="fas fa-question-circle"></i>
                      </span>
                    </span>
                  </div>
                  <b-input-group>
                    <b-form-input type="text" v-model="converter"></b-form-input>
                  </b-input-group>
                  <small class="help-block">拡張子の設定（例）txt、php、aspx、js ...</small>
              </b-form-group>
            </b-col>
          </b-row>
          <b-row>
            <b-col>
              <b-form-group :label-cols="3">
                <div slot="label" class="font-weight-bold">
                  <span v-b-tooltip.hover.right title="監視しているフォルダー内のサブ条件のサイズを持つファイルのみをスキャンします">
                    最大ファイルサイズ
                    <span class="text-info">

                      <i style="cursor:pointer" class="fas fa-question-circle"></i>
                    </span>
                  </span>
                </div>
                <b-input-group>
                    <b-form-input type="number" v-model="model.setting.max_filesize"></b-form-input>
                </b-input-group>
                <small class="help-block">基本 : 10M</small>
              </b-form-group>
            </b-col>
          </b-row>
          <b-row>
            <b-col>
              <b-form-group :label-cols="3">
                <div slot="label" class="font-weight-bold">
                  <span v-b-tooltip.hover.right title="更新されたシステム パターンを自動的に適用して確認するかどうかを設定します。これらの設定を有効にすることをお勧めします。使用しない場合は、更新されたパターンを手動で更新できます">
                    パターンを自動で適用
                    <span class="text-info">
                      <i style="cursor:pointer" class="fas fa-question-circle"></i>
                    </span>
                  </span>
                  <!-- 시스템 패턴 자동 적용 -->
                </div>
                <b-form-radio-group v-model="model.is_allow_system">
                  <b-form-radio :value="true">有効</b-form-radio>
                  <b-form-radio :value="false">無効</b-form-radio>
                  <b-button class="btn-add" size="sm" variant="success" @click="system_pattern_manual" :disabled="model.is_allow_system == true || model.available_system_pattern_count < 1 || this.model.is_testing">
                    <b-badge pill variant="warning" >{{ model.available_system_pattern_count | number }}</b-badge>
                    <span v-if="!model.is_testing">
                      使用可能な新システムパターン
                    </span>
                    <span v-else>
                      テスト依頼の結果はメールにてお知らせします。
                    </span>
                  </b-button>
                </b-form-radio-group>
                <small class="text-danger">有効化を推奨</small>
              </b-form-group>
            </b-col>
          </b-row>
          <hr>
          <b-row class="text-center">
            <b-col sm="12">
              <p style="display:inline-block; cursor: pointer;" @click="model.setting.limit_mode = !model.setting.limit_mode">
                <span v-b-tooltip.hover.right title="インストールされているサーバーのリソースを監視します 設定された制限に達した場合にメール通知を受け取ることができます">
                  リソース監視アラート
                  <span class="text-info">

                    <i style="cursor:pointer" class="fas fa-question-circle"></i>
                  </span>
                </span>
                <!-- <span class="mr-3">자원 모니터링 알림</span> -->
                <i v-if="model.setting.limit_mode" class="fa fa-refresh fa-spin"></i>
              </p>
              <c-switch class="float-right" color="success" label variant="pill" v-model="model.setting.limit_mode"/>
              <br>
              <small class="text-danger">システムリソースがしきい値以上である場合、最初の通知が発生します <br> そして、基準値が正常な場合に告知が可能です。しきい値90％、基準60％を推奨しています。 </small>
            </b-col>
          </b-row>
          <hr>
          <b-row class="text-center">
            <b-col sm="2" class="mt-2">CPUしきい値(90%)</b-col>
            <b-col sm="2">
              <b-input-group append="%" class="mt-1 mb-1">
                  <b-form-input :number="true" type="number" placeholder="90" v-model="model.setting.limit_cpu"></b-form-input>
              </b-input-group>
            </b-col>
            <b-col sm="2" class="mt-2">RAMしきい値(90%)</b-col>
            <b-col sm="2">
              <b-input-group append="%" class="mt-1 mb-1">
                  <b-form-input :number="true" type="number" placeholder="90" v-model="model.setting.limit_ram"></b-form-input>
              </b-input-group>
            </b-col>
            <b-col sm="2" class="mt-2">ディスクしきい値(90%)</b-col>
            <b-col sm="2">
              <b-input-group append="%" class="mt-1 mb-1">
                  <b-form-input :number="true" type="number" placeholder="90" v-model="model.setting.limit_disk"></b-form-input>
              </b-input-group>
            </b-col>
          </b-row>
          <b-row class="text-center">
            <!-- 여기서 라인 나눔 -->
            <b-col sm="2" class="mt-2">CPU基準値(60%)</b-col>
            <b-col sm="2">
              <b-input-group append="%" class="mt-1 mb-1">
                  <b-form-input :number="true" type="number" v-model="model.setting.resolve_cpu"></b-form-input>
              </b-input-group>
            </b-col>
            <b-col sm="2" class="mt-2">RAM基準値(60%)</b-col>
            <b-col sm="2">
              <b-input-group append="%" class="mt-1 mb-1">
                  <b-form-input :number="true" type="number" v-model="model.setting.resolve_ram"></b-form-input>
              </b-input-group>
            </b-col>
            <b-col sm="2" class="mt-2">Disk基準値(60%)</b-col>
            <b-col sm="2">
              <b-input-group append="%" class="mt-1 mb-1">
                  <b-form-input :number="true" type="number" v-model="model.setting.resolve_disk"></b-form-input>
              </b-input-group>
            </b-col>
          </b-row>
        </b-collapse>
        </b-tab>
        <!-- 점검 탭 -->
        <b-tab title="チェック中" v-if="(model.status && model.alive)">
          <b-row>
            <b-col md="3">
              <b-form-group v-if="model && model.status">
                エージェントの状態
              </b-form-group>
            </b-col>
            <b-col md="2">
              {{model.status.running && model.status.is_real_time == false ? (scan_status.stopping ? "On Stopping" : `On Going`) : 'On Standby'}}
              <span v-if="model.status.running && model.status.is_real_time == false">
                <i class="fa fa-refresh fa-spin"></i>
              </span>
            </b-col>
            <b-col md="2">
              <b-button block v-if="model.status && !scan_status.running" size="sm" variant="primary" @click="start_scan" :disabled="!model.ms">
                今すぐ開始
              </b-button>
              <b-button block v-else size="sm" variant="danger" @click="stop_scan" :disabled="scan_status.stopping || !model.status.percentFile">
                <b-spinner v-if="model.status && !model.status.percentFile" small type="grow"></b-spinner>
                {{ model.status && !model.status.percentFile ? 'Loading' : 'Suspend now'}}
              </b-button>
            </b-col>
            <b-col md="6"></b-col>
          </b-row>
          <b-row>
            <b-col md="12">
              <b-form-group v-show="runStatus">
                チェック開始 -
                <span v-if="model.status && !model.status.percentFile">loading</span>
                <span v-else> {{model.status.scan_date | datetime}}</span>
                <span class="text-danger float-right">* スキャンとファイルのチェックを同時に行うため、進捗にばらつきが生じることがあります </span>
              </b-form-group>
            </b-col>
          </b-row>
          <hr v-if="runStatus">
          <b-progress v-show="runStatus" class="mt-2 animated fadeIn fadeOut" :max="model.status.percentFolder != 0 ? 200 : 100" show-value ref="progressbar">
            <b-progress-bar v-if="model.status.percentFolder != 0" :label="`${model.status.percentFolder || 0} %`" show-progress animated :precision="1" :value="model.status.percentFolder || 0" variant="info"></b-progress-bar>
            <b-progress-bar :label="`${model.status.percentFile || 0} %`" show-progress animated :precision="1" :value="model.status.percentFile || 0" variant="dark"></b-progress-bar>
          </b-progress>
          <hr>
          <b-row>
            <b-col>
              <b-form-group :label-cols="3" label="現在の進捗状況" v-if="runStatus">
              <span> <b-badge pill variant="dark" >ファイル</b-badge> : {{model.status.scan_count}} of {{model.status.scan_count_left}}  チェック完了 - {{ model.status.percentFile || 0 }} % </span> <br>
              </b-form-group>
            </b-col>
          </b-row>
          <b-row>
            <b-col md="12">
              <b-form-group :label-cols="3" :label="`現在のランチャーの開始時刻`" v-if="model && model.status">
                <label v-if="scan_status.running && !model.status.percentFile">Loading.....</label>
                <label v-else>{{model.status && model.status.start | datetime}}</label>
              </b-form-group>
            </b-col>
          </b-row>
          <b-row>
            <b-col md="12">
              <b-form-group :label-cols="3" :label="`最近のチェックの詳細`" v-if="model && model.status"><label>{{model.updated_at | datetime}} / トータル : {{model.status.last_scan_count || 0}} ファイル</label></b-form-group>
            </b-col>
          </b-row>
          <b-row>
            <b-col md="12">
              <b-form-group :label-cols="3" :label="`最近の検出の詳細`" v-if="model && model.status"><label>{{model.updated_at | datetime}} / トータル : {{model.status.last_detect_count || 0}} 検出 </label></b-form-group>
            </b-col>
          </b-row>
        </b-tab>
        <b-tab title="チェック中" v-else>
          <b-row>
            <b-col md="5">
              エージェントオフライン
            </b-col>
          </b-row>
        </b-tab>
        <!-- 탐지 탭 -->
        <b-tab @click="$refs._dl && $refs._dl.refresh()">
          <template slot="title">
            検出リスト
            <span class="badge badge-danger">{{`${detect_item || 0}`}}</span>
          </template>
          <b-table ref="_dl" striped hover small class="table_add" :items="getDetect" :fields="detect_fields" :current-page="so_detect.currentPage" :per-page="so_detect.perPage" v-show="detect_item">
            <template slot="created_at" slot-scope="row">{{ row.item.created_at | datetime }}</template>
            <template slot="path" slot-scope="row">{{row.item.path}}</template>
            <template slot="type" slot-scope="row">{{ parser_type(row.item) }}</template>
            <template slot="select" slot-scope="row">
              <b-btn size="sm" @click="detect_select(row.item)" variant="dark">確認</b-btn>
              <b-btn size="sm" @click="backup(row.item)" variant="warning"> 隔離 </b-btn>
              <b-btn class="btn-add" size="sm" @click="detect_exception(row.item)" variant="success"> 例外 </b-btn>
              <b-btn size="sm" @click="detect_download(row.item)" variant="primary"> ダウンロード </b-btn>
              <!-- <b-btn size="sm" @click="backup_remove_raw(row.item)" variant="danger"> 削除 </b-btn> -->
            </template>
          </b-table>
          <hr>
          <b-col class="md-4" v-if="detect_item">
            <b-pagination size="sm"  align="center" :total-rows="detect_item" :per-page="so_detect.perPage" v-model="so_detect.currentPage" prev-text="<" next-text=">" />
          </b-col>
          <template v-if="!detect_item">
            <strong>履歴が検出されません</strong>
          </template>
          <!-- 상세보기 모달 -->
          <b-modal size="lg" ref="detect_modalRef" title="検出結果" ok-only>
            <div class="text-center h6 w-100">
              <table class="text-center h5 w-100">
                <thead>
                  <tr>
                    <th style="background-color:orange;border-radius: 12px;" colspan="2">検出情報</th>
                  </tr>
                </thead>
                <tbody class="h6">
                  <tr>
                    <td class="p-2">エージェント</td>
                    <td class="p-2">{{model.name}}[{{model.host}}@{{model.ip_addr}}]</td>
                  </tr>
                  <tr>
                    <td class="p-2">IP Address</td>
                    <td class="p-2">{{ model.ip_addr_public }} / {{ model.ip_addr_private }}</td>
                  </tr>
                  <tr>
                    <td class="p-2">検出時間</td>
                    <td class="p-2">{{detect_model.created_at | datetime}}</td>
                  </tr>
                  <tr>
                    <td class="p-2">隔離</td>
                    <td class="p-2 text-danger">{{detect_model.is_backup ? `Yes` : `No`}}</td>
                  </tr>
                  <tr>
                    <td class="p-2">タイプ</td>
                    <td class="p-2">{{detect_model && detect_model.description ? detect_model.description.type : '-'}}</td>
                  </tr>
                  <tr>
                    <td class="p-2">コード</td>
                    <td class="p-2">{{detect_model && detect_model.description ? detect_model.description.code : '-'}}</td>
                  </tr>
                  <tr>
                    <td class="p-2">ライン</td>
                    <td class="p-2" v-if="detect_model && detect_model.description">{{detect_model.description.numerical > 0 ? detect_model.description.numerical : '-'}}</td>
                    <td class="p-2" v-else>-</td>
                  </tr>
                </tbody>
              </table>
              <b-btn size="sm" @click="copyText('ph_content')" variant="primary" block> パス </b-btn>
              <pre class="mt-4" ref="ph_content" id="ph_content">{{detect_model.path}}</pre>
              <b-btn size="sm" @click="copyText('ph_data')" variant="primary" block> 検出データ（その行の一部のみ表示） </b-btn>
              <pre class="mt-4" ref="ph_data" id="ph_data" v-if="detect_model && detect_model.description">{{detect_model.description.value ? detect_model.description.value : '-'}}</pre>
            </div>
          </b-modal>
        </b-tab>
        <!-- 결과 탭 -->
        <b-tab @click="$refs._rl && $refs._rl.refresh()">
          <template slot="title">
            結果一覧
            <span class="badge badge-primary">{{`${result_item || 0}`}}</span>
          </template>
          <b-table ref="_rl" striped hover small fixed class="table_add" :items="getResult" :fields="result_fields" :current-page="so_result.currentPage" :per-page="so_result.perPage" v-show="result_item">
            <template slot="scan_time" slot-scope="row">
              {{ row.item.scan_time | datetime }}
              ({{row.item.scanning_time}})
            </template>
            <template slot="scan_folder" slot-scope="row">{{row.item.scan_folder | number}}</template>
            <template slot="scan_count" slot-scope="row">{{row.item.scan_count | number}}</template>
            <template slot="detect_count" slot-scope="row">{{row.item.detect_count | number}}</template>
            <template slot="select" slot-scope="row">
              <b-button class="btn-secondary" size="sm" @click="result_select(row.item)">確認</b-button>
            </template>
          </b-table>
          <hr>
          <template v-if="!result_item">
            <strong>詳細は確認されていません</strong>
          </template>
          <b-col class="md-4" v-if="result_item">
            <b-pagination size="sm"  align="center" :total-rows="result_item" :per-page="so_result.perPage" v-model="so_result.currentPage" prev-text="<" next-text=">" />
          </b-col>
          <b-modal size="xl" ref="result_modalRef" title="" ok-only>
            <ResultDetail :id="result_model.id" />
          </b-modal>
        </b-tab>
        <!-- 격리 탭 -->
        <b-tab @click="save_box()" >
          <template slot="title">
            隔離
            <span class="badge badge-warning">{{`${safe_box ? safe_box.length : 0}`}}</span>
          </template>
          <b-table ref="safe_list" striped hover small fixed class="table_add" :items="safe_box" :fields="safe_fields" :current-page="so_isolation.currentPage" :per-page="so_isolation.perPage" v-show="safe_box && safe_box.length">
            <template slot="path" slot-scope="row">{{row.item.path}}</template>
            <template slot="hash" slot-scope="row">{{row.item.hash && row.item.hash.indexOf('.') > -1 ? row.item.hash.split('.')[0] : row.item.hash}}</template>
            <template slot="created_at" slot-scope="row">{{ row.item.data | datetime }}</template>
            <template slot="select" slot-scope="row">
              <b-btn class="btn-add" size="sm" @click="backup_restore(row.item)" variant="success">元に戻す</b-btn>
              <b-btn class="btn-add" size="sm" @click="backup_exception(row.item)" variant="success">例外</b-btn>
              <b-btn size="sm" @click="backup_remove_modal = true; remove_info = row.item; $refs.safe_list.refresh()" variant="danger">削除</b-btn>
              <b-btn size="sm" @click="backup_download(row.item)" variant="primary">ダウンロード</b-btn>
            </template>
          </b-table>
          <template v-if="!safe_box || !safe_box.length">
            <tr>
              <th>隔離パスが設定されていない、または隔離されたファイルが存在していません。</th>
            </tr>
          </template>
          <b-col class="md-4" v-if="this.safe_box && this.safe_box.length">
            <b-pagination size="sm"  align="center":total-rows="this.safe_box && this.safe_box.length" :per-page="so_isolation.perPage" v-model="so_isolation.currentPage" prev-text="<" next-text=">" />
          </b-col>
          <b-modal size="lg" v-model="backup_remove_modal" @ok="backup_remove(remove_info)" ref="safe_modalRef" title="削除">
            <p>
              本当に削除しますか？
            </p>
            <hr>
            <p>{{remove_info.path}} </p>
          </b-modal>
        </b-tab>
        <!-- <b-tab>
          <template slot="title">
            例外
            <span class="badge badge-success">{{`${model.setting && model.setting.white_path ? model.setting.white_path.length : 0}`}}</span>
          </template>
          <white-Path :press="false" :show="true" :white_path="model.setting.white_path || []" @add="add_white_path" @save="save_setting" @remove="remove_path" @clear="model.setting.white_path = []"></white-Path>
        </b-tab> -->
        <b-tab>
          <template slot="title">
            WFDetector
            <b-img v-if="model && model.setting.forgery_mode" rounded src="img/checked.png" width="15" class="ml-1 mt-1 mb-1"></b-img>
          </template>
          <div>
            <b-jumbotron>
              <template v-if="model.setting.forgery_mode" slot="header">
                <b-img style="display: inline-block; width: 5%;" rounded :src="'img/checked.png'" class="mr-2"></b-img>
                <p style="display: inline-block;" class="h1">
                  WFDetectorの設定を有効にする
                </p>
              </template>
              <template v-else slot="header">
                <p class="h1 font-weight-bold">
                  偽造防止設定を有効にしてください!
                </p>
              </template>

              <template slot="lead">
                <p>
                  指定したフォルダー内のサブフォルダーやファイルが偽造されていないか検出します。設定やバックアップファイルの変更を監視します。
                </p>
                <p>
                  設定したフォルダーを確認します！設定ページで変更が可能です。
                </p>
                <b-row>
                <b-col>
                <div class="text-center" v-if="model.setting.forgery_mode && model.setting.snapshot.watching.length">
                  <span style="position: relative; top: 1.8rem; background-color: #e4e7ea; font-weight: bold; padding: 0 15px;">
                    偽装監視フォルダー
                  </span>
                  <hr>
                </div>
                <small v-for="(item, index) in model.setting.snapshot.watching" v-bind:key="index+'_watching'">
                  {{item}}
                </small>
              </b-col>
              <b-col>
                <div class="text-center" v-if="model.setting.forgery_mode && model.setting.snapshot.watching.length">
                  <span style="position: relative; top: 1.8rem; background-color: #e4e7ea; font-weight: bold; padding: 0 15px;">
                    例外フォルダー
                  </span>
                  <hr>
                </div>
                <small v-for="(item, index) in model.setting.snapshot.white_path" v-bind:key="index+'_white_path'">
                  {{item}}
                </small>
              </b-col>
              <b-col>
                <div class="text-center" v-if="model.setting.forgery_mode && model.setting.snapshot.watching.length">
                  <span style="position: relative; top: 1.8rem; background-color: #e4e7ea; font-weight: bold; padding: 0 15px;">
                    例外ファイル
                  </span>
                  <hr>
                </div>
                <small v-for="(item, index) in model.setting.snapshot.white_file" v-bind:key="index+'_white_file'">
                  {{item}}
                </small>
              </b-col>
            </b-row>
              </template>
              <hr>
              <template>
                <b-button block variant="warning" to="/integrity/wsfinder">
                  <span v-if="model.setting.snapshot.watching && model.setting.snapshot.watching.length > 0">
                    設定の変更 :D
                  </span>
                  <span v-else>
                    今すぐ開始 :D
                  </span>
                </b-button>
              </template>
            </b-jumbotron>
          </div>
        </b-tab>
    </b-tabs>
    <b-modal size="xl" ref="scan_modalRef" title="" ok-only>
      <ResultDetail :result_data="result"/>
    </b-modal>
    <b-modal title="削除"  class="modal-danger" v-model="del_confirm" @ok="remove" @cancel="del_nickname = '';" header-bg-variant="danger" ok-variant="danger">
      <p>エージェントを削除する場合</p>
      <p>サーバもdeleteコマンドを実行する必要があります。</p>
      <p>
        サーバから自動的に削除されることはありません。
      </p>
      <p>マニュアルに従って削除してください。</p>
      <p> <b> * エージェント名の確認 </b> </p>
      <p> エージェント名を削除 : {{model.name}}  </p>
      <b-form-input v-model="del_nickname" placeholder="登録を解除するサーバーの名前を入力します。"></b-form-input>
    </b-modal>

    <b-modal hide-footer title="ポリシーを適用するエージェント" size="xl" v-model="apply_modal" header-bg-variant='warning'>
      <b-badge variant="success" v-for="(item, index) in apply_all_server" :key="index+'_a'" class="m-1">
        <h6 @click="multi_remove(index)" style="cursor:pointer;">{{item.name}} <span class="m-1" style="cursor:pointer;">X</span></h6>
      </b-badge>
      <hr>
      <agent-List :agent_id="model.id" :list_selected="apply_all_server"  :only_select="true" :view_detail="true" :server_agent="server_agent" @multi_clear="multi_clear" @multi_all="multi_all" @multi_one="multi_one"></agent-List>
      <hr>
      <b-button block variant="warning" @click="apply_confirm_modal = true" class="m-1">適用</b-button>
      <b-button block variant="info" @click="apply_modal = false" class="m-1">閉じる</b-button>
    </b-modal>

    <b-modal hide-footer title="確認" size="xm" v-model="apply_confirm_modal" header-bg-variant='danger'>
      選択したエージェントに設定を適用してもよろしいですか?
      <hr>
      <b-button block variant="danger" @click="multi_save" class="m-1">適用</b-button>
      <b-button block variant="info" @click="apply_confirm_modal = false" class="m-1">閉じる</b-button>
    </b-modal>
    <hr>
    <b-button v-if="quick_setting_status == false" class="float-left" variant="link" @click="quick_setting_status = true">クイックガイドスタート</b-button>
    <b-button size="sm" class="float-right text-white" variant="secondary" @click="list"> 一覧 </b-button>

    <b-modal title="変更"  class="modal-info" v-model="modal_modify" @ok="apply" header-bg-variant="info" ok-variant="info">
      <p> サーバのニックネームを変更することができます。</p>
      <p> 変更するニックネームを入力してください。初回はサーバ名をホスト名とします。 </p>
      <p> <b> * サーバ名の確認 </b> </p>
      <p> オリジンサーバのニックネーム : {{model.name}}  </p>

      <b-form-input v-model="modify_nickname" placeholder="名前を変更するための入力"></b-form-input>
    </b-modal>

    <b-modal title="アップグレード"  class="modal-success" v-model="modal_upgrade" @ok="upgrade" header-bg-variant="success" ok-variant="success">
      <p>本当にエージェントをアップグレードしてよろしいですか？</p>
      <p>現材のバージョン({{model.version}}),より上位</p>
    </b-modal>
    <b-modal title="分離パスの履歴"  class="modal-info" v-model="modal_scan_list_history" @ok="modal_scan_list_history = false" ok-only header-bg-variant="info" ok-variant="info">
      <p v-if="!model.setting.backup_path_history || !model.setting.backup_path_history.length">過去データがありません</p>
      <table v-else>
        <thead class="text-center font-weight-bold border-bottom">
          <tr>
            <td>
              日時
            </td>
            <td>
              フォルダー一覧
            </td>
          </tr>
        </thead>
        <tbody>
          <tr v-for="(x, index) in model.setting.backup_path_history" v-bind:key="index+'_b'">
            <td class="text-center" style="width: 40%">
              {{x.updated_at | sdate}}
            </td>
            <td>
              <p class="m-1">{{ x.target }}</p>
              <!-- <p class="m-1" v-for="(y, index) in x.target_sub">{{y}}</p> -->
              <!-- TODO : 향후 이전 기록 바로 적용 추가 될 수 있음 -->
            </td>
          </tr>
        </tbody>
      </table>
    </b-modal>
  </b-card>
</div>
</template>

<script>
import App from './app.js'; export default Object.assign({}, App);
</script>
